/**
 * Internal EAN-13–format codes for pharmacy-owned items (not GS1-issued GTINs).
 * Leading "2" + 3-digit clinic hash + 8 random digits + standard check digit.
 * Uniqueness should still be enforced per pharmacy on the server when possible.
 */

/**
 * @param {string} clinicId
 * @returns {string} 3-digit string
 */
export function clinicNumericBlock(clinicId) {
	if (!clinicId) return "000";
	let h = 0;
	const s = String(clinicId);
	for (let i = 0; i < s.length; i += 1) {
		h = (h * 31 + s.charCodeAt(i)) >>> 0;
	}
	return String(h % 1000).padStart(3, "0");
}

function randomDigits(count) {
	const arr = new Uint8Array(count);
	if (typeof crypto !== "undefined" && crypto.getRandomValues) {
		crypto.getRandomValues(arr);
	} else {
		for (let i = 0; i < count; i += 1) arr[i] = Math.floor(Math.random() * 256);
	}
	let s = "";
	for (let i = 0; i < count; i += 1) {
		s += String(arr[i] % 10);
	}
	return s;
}

/**
 * GS1 EAN-13 check digit for first 12 digits (left to right).
 * @param {string} body12 exactly 12 digits
 */
export function ean13CheckDigit(body12) {
	if (!/^\d{12}$/.test(body12)) {
		throw new Error("EAN-13 body must be exactly 12 digits");
	}
	let sum = 0;
	for (let i = 0; i < 12; i += 1) {
		const digit = parseInt(body12[11 - i], 10);
		sum += digit * (i % 2 === 0 ? 3 : 1);
	}
	return (10 - (sum % 10)) % 10;
}

/**
 * @param {string} [clinicId] hospital / clinic id from pharmacy context
 * @returns {string} 13-digit string
 */
export function generateInternalEan13(clinicId) {
	const clinic = clinicNumericBlock(clinicId);
	const rnd = randomDigits(8);
	const body12 = `2${clinic}${rnd}`;
	return `${body12}${ean13CheckDigit(body12)}`;
}
